import { Trans } from '@lingui/macro';
import Button from 'MUI_Kit/components/CustomButtons/Button';
import React from 'react';

export default () => {
  const color = '#000';
  const isSmallHeight = window.innerHeight <= 600;

  return (
    <div
      style={!isSmallHeight ? { position: 'absolute', bottom: 0, opacity: 0.2 } : { opacity: 0.2 }}
      className="flex-center-row">
      <Button
        simple
        href="https://doopage.com"
        target="_blank"
        style={{ color, borderRight: '1px solid ' + color, borderRadius: 0 }}>
        <Trans>Trang chủ</Trans>
      </Button>

      <Button simple href="https://doopage.com/privacy-policy/" target="_blank" style={{ color }}>
        <Trans>Chính sách bảo mật</Trans>
      </Button>

      <Button
        simple
        href="https://m.me/doopagecrm?ref=support"
        target="_blank"
        style={{ color, borderLeft: '1px solid ' + color, borderRadius: 0 }}>
        <Trans>Liên hệ</Trans>
      </Button>
    </div>
  );
};
